var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.712,
    height: 16.834,
    viewBox: "2696 4609 16.712 16.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2709.93 4622.28a5.794 5.794 0 0 0-1.514-2.696 5.718 5.718 0 0 0-2.09-1.346 3.549 3.549 0 0 0 1.548-2.934 3.534 3.534 0 0 0-3.517-3.542 3.534 3.534 0 0 0-3.518 3.542 3.542 3.542 0 0 0 .835 2.29 3.555 3.555 0 0 0 .715.645 5.773 5.773 0 0 0-3.605 4.04 7.428 7.428 0 0 1-1.785-4.323 7.555 7.555 0 0 1-.02-.54c0-4.096 3.31-7.43 7.378-7.43a7.412 7.412 0 0 1 7.377 7.43 7.425 7.425 0 0 1-1.07 3.85 7.47 7.47 0 0 1-.735 1.014Zm.335-10.815a8.271 8.271 0 0 0-5.908-2.465 8.271 8.271 0 0 0-5.91 2.465 8.393 8.393 0 0 0-2.447 5.952c0 2.248.87 4.362 2.448 5.951a8.271 8.271 0 0 0 5.909 2.465c2.232 0 4.33-.875 5.908-2.465a8.393 8.393 0 0 0 2.448-5.951c0-2.248-.87-4.362-2.448-5.952Zm-5.908 7.412a4.793 4.793 0 0 0-4.73 4.237 7.424 7.424 0 0 0 .825.604 7.293 7.293 0 0 0 3.905 1.13 7.404 7.404 0 0 0 .377-.01 7.314 7.314 0 0 0 4.352-1.724 4.806 4.806 0 0 0-1.362-2.832 4.714 4.714 0 0 0-3.367-1.405Zm-2.538-3.573a2.55 2.55 0 0 0 2.538 2.557 2.55 2.55 0 0 0 2.538-2.557 2.55 2.55 0 0 0-2.538-2.556 2.55 2.55 0 0 0-2.538 2.556Z",
    fill: "#2a2a2a",
    fillRule: "evenodd",
    "data-name": "user"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2f6e6ad1028d45a02f1324b07e28ce3d.svg";
export { ForwardRef as ReactComponent };